// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.geo-locate-wrapper{height:100%;display:flex}`, "",{"version":3,"sources":["webpack://./client/components/GeoLocate/index.scss"],"names":[],"mappings":"AAAA,oBACE,WAAA,CACA,YAAA","sourcesContent":[".geo-locate-wrapper {\n  height: 100%;\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
